import { request } from '@/common/request';

// 全局请求前缀
export const apiPrefix = '/admin-imdt/api';

// 下载文件
export const download = (key: string) => {
  const url = '/cos/download';
  return request.post(
    url,
    { key },
    {
      // @ts-ignore
      hiddenErrorMsg: true,
    },
  );
};

/**
 * 创建短链
 * @param url 原始长链接
 */
export const createShortLink = (params: { type: string; ttlSeconds?: number; longUrl: string }) => {
  const api = '/shortlink/create';
  return request.post(api, params);
};

/**
 * 短链重定向
 * @param shortCode 短码
 */
export const redirectShortLink = (shortCode: string) => {
  const api = `/s/${shortCode}`;
  return request.get(api, {
    responseType: 'text',
    transformResponse: (data: any) => data,
  });
};

export default {
  apiPrefix,
  createShortLink,
  redirectShortLink,
};
